import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import { RouteItem } from "../../../../../interface/RouteItem";
import { useTranslation } from "react-i18next";
import Title from "./Title";
import { SidebarMenu } from "../../../../../enum/SidebarMenu";
import { useAppSelector } from "../../../../../hook/useAppSelector";
import { useAppDispatch } from "../../../../../hook/useAppDispatch";
import { setActiveSidebarElement } from "../../../../../store/slice/config/config";

interface Props {
  title: string;
  menuRoutes: RouteItem[];
  icon: string;
  sidebarMenuType: SidebarMenu;
}

const DropdownMenu: React.FC<Props> = ({
  title,
  menuRoutes,
  icon,
  sidebarMenuType,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useRef(false);
  const { t } = useTranslation();
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [menuHeight, setMenuHeight] = useState(0);
  const activeSidebarElement = useAppSelector(
    (state) => state.configSlice.activeSidebarElement
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isOpen && menuRef.current) {
      setMenuHeight(menuRef.current.scrollHeight);
    } else {
      setMenuHeight(0);
    }
  }, [isOpen, menuRoutes]);

  useEffect(() => {
    const handler = (): void => {
      if (!open.current) {
        setIsOpen(false);
      }

      open.current = false;
    };

    window.addEventListener("click", handler);

    return () => window.removeEventListener("click", handler);
  }, []);

  const handleMenuClick = (): void => {
    if (!isOpen) {
      open.current = true;
    }

    setIsOpen((prevState) => !prevState);
    dispatch(setActiveSidebarElement(sidebarMenuType));
  };

  return (
    <div
      onClick={handleMenuClick}
      className={`sidebar_element_wrapper ${isOpen ? "opened" : ""} ${
        activeSidebarElement === sidebarMenuType ? "active" : ""
      }`}
    >
      <Title isOpen={isOpen} title={title} icon={icon}></Title>

      <div
        className={`menu ${isOpen ? "opened" : ""}`}
        onClick={(e) => e.stopPropagation()}
        ref={menuRef}
        style={{
          maxHeight: `${menuHeight}px`,
          opacity: isOpen ? 1 : 0,
          overflow: "hidden",
          transition: "max-height 0.3s ease, opacity 0.3s ease",
        }}
      >
        {menuRoutes?.map((route) => (
          <NavLink
            key={`route.path${route.path}_route.label${route.label}`}
            to={`${route.path}`}
            onClick={route.onClick}
          >
            <p>{t(`${route.label}`)}</p>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default DropdownMenu;
